import { render, staticRenderFns } from "./msgFoot.vue?vue&type=template&id=0a4e8aa9&"
import script from "./msgFoot.vue?vue&type=script&lang=js&"
export * from "./msgFoot.vue?vue&type=script&lang=js&"
import style0 from "./msgFoot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports